import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

export const ExportRangeSelectModel = ({ openModel, onClose }) => {
  const [openModal, setOpenModal] = useState(openModel);

  useEffect(() => {
    if (openModel) {
      setOpenModal(true);

      Swal.fire({
        title: "Select Date Range First!",
        text: "Please select a date range before exporting the data!",
        icon: "warning",
        iconColor: "#FCDD00",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCDD00",
        customClass: {
          confirmButton: "custom-confirm-button",
          cancelButton: "custom-cancel-button",
        },
      }).then(() => {
        setOpenModal(false);
        onClose?.(); // notify parent that modal closed
      });
    }
  }, [openModel, onClose]);

  return null; // don't render anything, SweetAlert handles UI
};
